import type { LeadFeedRow } from './leadFeedMapper';

function escapeCsvCell(
  value: string | number | boolean | undefined | null
): string {
  const s = value === null || value === undefined ? '' : String(value);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/** Export columns for My Leads CSV; excludes visitor message and internal IDs. */
const CSV_COLUMNS: {
  header: string;
  value: (r: LeadFeedRow) => string | boolean | undefined | null;
}[] = [
  {
    header: 'Lead type',
    value: r => (r.leadType === 'buyer' ? 'Buyer' : 'Tenant')
  },
  { header: 'Name', value: r => r.name },
  { header: 'Phone', value: r => r.phone },
  { header: 'Email', value: r => r.email },
  { header: 'Property type', value: r => r.propertyType },
  { header: 'Property price', value: r => r.propertyPrice ?? '' },
  {
    header: 'MLS number showing request',
    value: r => r.mlsNumber ?? ''
  },
  {
    header: 'Address of showing request',
    value: r => r.address
  },
  { header: 'Date Lead Created', value: r => r.createdAt },
  { header: 'Purchased date', value: r => r.purchasedAtIso ?? '' },
  { header: 'Clearance?', value: r => (r.isClearance ? 'Yes' : 'No') }
];

export function leadFeedRowsToCsv(rows: LeadFeedRow[]): string {
  const headerLine = CSV_COLUMNS.map(c => escapeCsvCell(c.header)).join(',');
  const dataLines = rows.map(row =>
    CSV_COLUMNS.map(c => escapeCsvCell(c.value(row))).join(',')
  );
  return [headerLine, ...dataLines].join('\r\n');
}

export function downloadLeadFeedCsv(
  rows: LeadFeedRow[],
  filenameBase = 'brokermax-leads'
): void {
  const csv = leadFeedRowsToCsv(rows);
  const blob = new Blob(['\ufeff', csv], {
    type: 'text/csv;charset=utf-8;'
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filenameBase}-${new Date().toISOString().slice(0, 10)}.csv`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
